__turbopack_context__.v({
  "policy_togglebtn_wrapper": "Fju4MG_policy_togglebtn_wrapper",
  "toggle_btn": "Fju4MG_toggle_btn",
});
